import React from "react";
import crest from "../../../../assets/DuPontFamilyCrest.png";

function Landing() {
  return (
    <div className="max-w-[1024px] mx-auto flex flex-col items-center">
      <div className="flex flex-col rounded-[12px] shadow-sm p-[32px] bg-white dark:bg-darkCard border border-dupontCreamDk dark:border-darkGold/10 gap-y-[16px]">
        <img
          src={crest}
          alt="du Pont family crest"
          className="block w-[120px] h-auto mx-auto mb-[8px]"
        />
        <p className="text-[17px] font-body text-dupontBlue dark:text-darkText leading-relaxed">
          Facebook was good, Instagram is solid, but there is something
          about those mediums that is not effective. It's not centralized
          and there is all this other noise. When you are trying to connect
          with a family member you want it to be direct to be streamlined.
        </p>
        <p className="text-[17px] font-body text-dupontBlue dark:text-darkText leading-relaxed">
          That is why everything cousin to cousin now lives here in one hub:
          the Scrapbook, the Directory, your Profile, and Correspondence.
        </p>
        <p className="text-[17px] font-body text-dupontBlue dark:text-darkText leading-relaxed">
          The Directory provides an easy-to-use search function for a cousin.
          This will take you to a profile for that cousin. But here is the
          kicker, each individual user will have their own chosen amount of
          information displayed.
        </p>
        <p className="text-[17px] font-body text-dupontBlue dark:text-darkText leading-relaxed">
          Whether that be a photo, or a phone number, email, where are you:
          international or lower forty-eight, etc. You could add a
          description about the work you do, or an interest that you are
          passionate about, or perhaps something completely different. But
          you also could have none of that!
        </p>
        <p className="text-[17px] font-body text-dupontBlue dark:text-darkText leading-relaxed">
          This will allow each cousin to have a high-level privacy and get
          to make their own decision about information given. But this site
          will be secure enough that if you would want to put a town and a
          photo, that would be more than safe.
        </p>
        <p className="text-[17px] font-body text-dupontBlue dark:text-darkText leading-relaxed">
          We do not want this to be a pressure but this app contains a
          family tree that has more sensitive information. Like DOBs and
          relatives. But the point of this is that you could be surfing it
          to find a cousin who lives in Italy. Maybe you are trying to see
          which state has the most cousins or perhaps you are looking to
          connect with a cousin and you remember their email but forgot
          their name.
        </p>
        <p className="text-[17px] font-body text-dupontBlue dark:text-darkText leading-relaxed">
          Any geographical information will be loose and nonspecific.
          Personal information is at your discretion to share or have as a
          part of your profile. And most importantly, you can choose if you
          even want to receive a direct message or if you just want to be
          incognito. This connect feature and the information it represents
          will be consent driven.
        </p>
        <p className="text-[17px] font-body text-dupontBlue dark:text-darkText leading-relaxed">
          Allow us to have a way to contact each other, through respectful
          means and levels of eagerness, enabling all to feel like they have
          the option to but are not burdened by connecting. While also
          representing where cousins are — so during moments of travel or
          networking there is a general census of who is doing what and
          where you can connect with them!
        </p>
      </div>
    </div>
  );
}

export default Landing;
